import { usePublicationMeta } from '../components/editorial/PublicationShared';
import CapitalPartnerNetworkView from '../features/capitalPartnerNetwork/CapitalPartnerNetworkView';
import { CAPITAL_PARTNER_NETWORK_META } from '../features/capitalPartnerNetwork/content';

export default function CapitalPartnerNetworkPage() {
  usePublicationMeta(
    CAPITAL_PARTNER_NETWORK_META.title,
    CAPITAL_PARTNER_NETWORK_META.description,
  );

  return <CapitalPartnerNetworkView />;
}
